export default class Constants {
	static readonly ACCESS_TOKEN = 'access_token';
}
